import {Fragment} from 'react'
import {uniqueId} from 'lodash'
import {Box, Text} from '@chakra-ui/react'

function renderTextWithLineBreaks(text: string) {
  const textParts = text?.split('\n')
  return textParts.map((part: string, i: number) => (
    <Fragment key={uniqueId(i.toString())}>
      <Text minH={'16px'}>{part}</Text>
      {i !== textParts.length - 1 && <Box h={'1px'} />}
    </Fragment>
  ))
}

export default renderTextWithLineBreaks
